import { RoutePaths } from './route-paths';
import { LoggingIn } from '../components/pages/logging-in';
import { PasswordSetUp } from '../components/pages/password-set-up';
import { PasswordRestore } from '../components/pages/password-restore';
import { LoggingInWithSso } from '../components/pages/logging-in-with-sso';
import { SignInNoticesShowing } from '../components/pages/sign-in-notices-showing';
import { SignInToPortal } from '../components/pages/sign-in-to-portal';

export const routes = [
	{
		path: RoutePaths.SIGN_IN,
		component: LoggingIn,
	},
	{
		path: RoutePaths.SIGN_IN_TO_PORTAL,
		component: SignInToPortal,
	},
	{
		path: RoutePaths.PASS_SETUP,
		component: PasswordSetUp,
	},
	{
		path: RoutePaths.SSO_SIGN_IN,
		component: LoggingInWithSso,
	},
	{
		path: RoutePaths.PASS_RESTORE,
		component: PasswordRestore,
	},
	{
		path: RoutePaths.SIGN_IN_NOTICES,
		component: SignInNoticesShowing,
	},
];
